import React from 'react';
import { useNavigate } from 'react-router-dom';
import FareEstimator from '../components/FareEstimator';
import './Home.css';

function Home() {
  const navigate = useNavigate();

  const scrollToEstimate = () => {
    const el = document.getElementById('estimate');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      {/* Promo Banner */}
      <section className="promo-banner">
        <div className="promo-inner">
          <div className="promo-text">
            <span className="promo-highlight">15% OFF</span>
            <span>your first round trip or </span>
            <span className="promo-highlight">10% OFF</span>
            <span>a one way ride. Get a free estimate in seconds!</span>
          </div>
          <button onClick={scrollToEstimate} className="promo-btn">Get Free Estimate</button>
        </div>
      </section>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Safe & Reliable Non-Emergency Medical Transport</h1>
          <p>Professional, compassionate transportation for medical appointments, dialysis, therapy, and hospital discharges.</p>
          <div className="hero-buttons">
            <button onClick={() => navigate('/book')} className="btn-primary">Schedule a Ride</button>
            <a href="tel:+12028162344" className="btn-secondary">Call Now: (202) 816-2344</a>
          </div>
        </div>
      </section>

      {/* Free Estimate Section */}
      <section className="estimate-section" id="estimate">
        <div className="container">
          <FareEstimator />
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">⏰</div>
              <h3>Early &amp; Late Rides</h3>
              <p>Service from 6 AM on weekdays, and after hours rides whenever our team can help.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👨‍⚕️</div>
              <h3>Trained Attendants</h3>
              <p>Certified medical transport specialists ensuring patient safety and comfort.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🚐</div>
              <h3>ADA Compliant Fleet</h3>
              <p>Wheelchair accessible vehicles with secure 4 point tie downs and ramps.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📍</div>
              <h3>Real-Time Tracking</h3>
              <p>GPS tracking and automated notifications for peace of mind.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Schedule Your Ride?</h2>
          <p>Book your non-emergency medical transport online or give us a call.</p>
          <button onClick={() => navigate('/book')} className="btn-primary">Book Now</button>
        </div>
      </section>
    </>
  );
}

export default Home;